import aiIcon from './img/ai.svg';
import aviIcon from './img/avi.svg';
import bmpIcon from './img/bmp.svg';
import csvIcon from './img/csv.svg';
import defaultIcon from './img/default.svg';
import dllIcon from './img/dll.svg';
import docIcon from './img/doc.svg';
import docxIcon from './img/docx.svg';
import dwgIcon from './img/dwg.svg';
import exeIcon from './img/exe.svg';
import flvIcon from './img/flv.svg';
import gifIcon from './img/gif.svg';
import htmlIcon from './img/html.svg';
import isoIcon from './img/iso.svg';
import javaIcon from './img/java.svg';
import jsonIcon from './img/json.svg';
import jpgIcon from './img/jpg.svg';
import mdbIcon from './img/mdb.svg';
import midIcon from './img/mid.svg';
import movIcon from './img/mov.svg';
import mp3Icon from './img/mp3.svg';
import mp4Icon from './img/mp4.svg';
import mpegIcon from './img/mpeg.svg';
import pdfIcon from './img/pdf.svg';
import pngIcon from './img/png.svg';
import pptIcon from './img/ppt.svg';
import psdIcon from './img/psd.svg';
import pubIcon from './img/pub.svg';
import rarIcon from './img/rar.svg';
import rssIcon from './img/rss.svg';
import svgIcon from './img/svg.svg';
import tiffIcon from './img/tiff.svg';
import txtIcon from './img/txt.svg';
import wavIcon from './img/wav.svg';
import wmaIcon from './img/wma.svg';
import xlsIcon from './img/xls.svg';
import xmlIcon from './img/xml.svg';
import zipIcon from './img/zip.svg';

const fileTypeIcon = {
	'default': defaultIcon,
	'text/csv': csvIcon,
	'application/msword': docIcon,
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': docxIcon,
	'application/vnd.ms-excel': xlsIcon,
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': xlsIcon,
	'application/vnd.ms-powerpoint': pptIcon,
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': pptIcon,
	'application/pdf': pdfIcon,
	'image/jpeg': jpgIcon,
	'image/png': pngIcon,
	'image/gif': gifIcon,
	'image/bmp': bmpIcon,
	'image/tiff': tiffIcon,
	'image/vnd.adobe.photoshop': psdIcon,
	'image/svg+xml': svgIcon,
	'text/plain': txtIcon,
	'text/html': htmlIcon,
	'application/x-msdos-program': exeIcon,
	'application/java-archive': javaIcon,
	'application/xml': xmlIcon,
	'text/xml': xmlIcon,
	'application/zip': zipIcon,
	'application/x-rar-compressed': rarIcon,
	'application/json': jsonIcon,
	'audio/mpeg': mp3Icon,
	'audio/wav': wavIcon,
	'audio/wave': wavIcon,
	'audio/x-ms-wma': wmaIcon,
	'video/x-msvideo': aviIcon,
	'video/mp4': mp4Icon,
	'video/mpeg': mpegIcon,
	'video/quicktime': movIcon,
	'application/vnd.ms-access': mdbIcon,
	'application/x-msaccess': mdbIcon,
	'application/vnd.ms-publisher': pubIcon,
	'application/x-mspublisher': pubIcon,
	'application/x-dwg': dwgIcon,
	'image/vnd.dwg': dwgIcon,
	'application/x-iso9660-image': isoIcon,
	'audio/midi': midIcon,
	'video/x-flv': flvIcon,
	'application/rss+xml': rssIcon,
	'application/rtf': docIcon,
	'application/vnd.adobe.illustrator': aiIcon,
	'application/postscript': aiIcon,
	'application/vnd.rar': rarIcon,
	'video/x-ms-wmv': wmaIcon,
	'application/vnd.oasis.opendocument.text': docxIcon,
	'application/vnd.oasis.opendocument.spreadsheet': xlsIcon,
	'application/vnd.oasis.opendocument.presentation': pptIcon,
	'application/x-msdownload': dllIcon,
	'application/vnd.microsoft.portable-executable': dllIcon
};

export default fileTypeIcon;
